import {useQueryClient} from '@tanstack/react-query';
import {UseFormGetValues} from 'react-hook-form';
import {useLocation} from 'react-router-dom';

import {AddressFormType} from 'desktop/types/addressType';
import {useHostDispatch} from 'hooks/hostHooks/hostHooks';
import {getAffId} from 'libs/analytics/affiliate';
import {flags, isUhcEnabled} from 'libs/rollout';
import {cookieStore, localStore} from 'libs/storage/storage';

import {SUBSCRIBER} from '../../constants/checkout';
import {
    createTransitional,
    deactivate,
    subscribe,
} from '../../store/reducers/newsletterSubscription/newsletterSubscription';

import {NEWSLETTER_SUBSCRIPTION_INFO_KEY} from './constants';
import {managerNewsletterSubscription} from './managerNewsletterSubscription';

/**
 * Function for fetching user's subscription status and sending the analytics event
 * @returns {() => void} - user's subscription status
 */
// TODO: GUSA-57076
export const useSubscriptionsMethod = (
    getFormValues: UseFormGetValues<AddressFormType>,
    hasLuxuryItem: boolean,
): ((arg0?: {}) => void) => {
    const shouldSkipSubscription = flags.dLuxurySpecialExperience.isEnabled() && hasLuxuryItem;
    const dispatch = useHostDispatch();
    const queryClient = useQueryClient();
    const {search} = useLocation();

    return (data: {} = {}): void => {
        if (isUhcEnabled() || shouldSkipSubscription) return;
        const formValues = getFormValues();
        // eslint-disable-next-line max-statements
        managerNewsletterSubscription.submitResult(type => {
            const email = managerNewsletterSubscription.getSubscriptionEmail();
            const isShown = managerNewsletterSubscription.getVisibility();
            if (type === 'SUBSCRIBED') {
                const action = subscribe(email, {
                    affId: getAffId({search}),
                    country: formValues.shippingAddress?.country,
                    from: 'checkout',
                    state: formValues.shippingAddress?.state,
                    subscriptionMethod: isShown ? 'Manual' : 'Auto',
                    verifyRealEmail: false,
                    ...data,
                });
                dispatch(action);
                action.payload.then(() => {
                    queryClient.removeQueries({
                        queryKey: [NEWSLETTER_SUBSCRIPTION_INFO_KEY, email],
                    });
                    localStore.set('email', email);
                });
            } else if (type === 'UNSUBSCRIBED') {
                const action = deactivate(email);
                dispatch(action);
                action.payload.then(() => {
                    queryClient.removeQueries({
                        queryKey: [NEWSLETTER_SUBSCRIPTION_INFO_KEY, email],
                    });
                    if (localStore.get('email')) localStore.remove('email');
                    if (cookieStore.get(SUBSCRIBER)) cookieStore.remove(SUBSCRIBER);
                });
            } else if (type === 'TRANSITIONAL') {
                const action = createTransitional(email);
                dispatch(action);
                action.payload.then(() => {
                    queryClient.removeQueries({
                        queryKey: [NEWSLETTER_SUBSCRIPTION_INFO_KEY, email],
                    });
                });
            }
        });
    };
};
